import ypopover from "./index.vue";

// 添加install方法 （插件方法）
const Yopover = {
  install: function (Vue) {
    Vue.component("YPopover", ypopover);
  },
};

export default Yopover;
